import Vue from "vue";
import Vuex, { StoreOptions, Plugin } from "vuex";
import { profile } from "./profile/index";
import { activity } from "./activity/index";
import { drinking } from "./drinking";
import { score } from "./score";
import { IRootState } from "./types";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

Vue.use(Vuex);

const state: IRootState = {
  currentRoute: ""
} as IRootState;

const gtmWatcher: Plugin<IRootState> = store => {
  const ignoreMutations: string[] = ["history/add", "history/save"];

  store.subscribe((mutation, state) => {
    if (!ignoreMutations.includes(mutation.type)) {
      try {
        if (mutation && state.$gtm) {
          state.$gtm.trackEvent({
            event: "mutation",
            type: mutation.type,
            value: mutation.payload,
            label: state.clientId
          });
        }
      } catch (e) {
        throw new Error(`Error with gtm.trackEvent: ${e}`);
      }
    }
  });
};

export const store: StoreOptions<IRootState> = {
  state,
  modules: {
    profile,
    drinking,
    score,
    activity
  },
  getters,
  mutations,
  actions,
  plugins: [gtmWatcher]
};

export default new Vuex.Store<IRootState>(store);
